import type { ServiceCategory } from "../api.js";

/**
 * Categories where sharing the property's auto-detected insights (lot size,
 * home sqft, mowable lawn area) actually helps a contractor scope a bid.
 * Kept in lockstep with INSIGHTS_SHARE_CATEGORIES in
 * /customer/api/src/domain/rfq.ts — the server only honors the flag for
 * these categories, so the wizard omits the field for everything else.
 */
export const INSIGHTS_SHARE_CATEGORIES: ReadonlySet<ServiceCategory> = new Set([
  "landscaping",
  "roofing",
  "cleaning",
  "pest_control",
  "painting",
]);

/**
 * Opt-in checkbox on the review step — default CHECKED, prominently placed so
 * the customer can uncheck before submitting. The value rides on the create
 * call as `sharePropertyInsights`.
 */
export function ShareInsightsField({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-3 rounded-lg border border-teal-200 bg-teal-50 p-3">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-5 w-5 shrink-0 accent-teal-700"
      />
      <span className="text-sm text-slate-700">
        Share my property details (lot size, home size, lawn area) with contractors so quotes are
        more accurate
      </span>
    </label>
  );
}
